<template>
  <v-layout wrap>
    <v-flex xs12 pb-0>
      <v-layout wrap align-center>
        <v-flex xs12 sm6 md6 lg6>
          <h1 class="headline">{{ $t('companiesList.title') }}</h1>
        </v-flex>
        <v-flex xs12 sm6 md6 lg6>
          <v-layout wrap align-center justify-end>
            <v-btn
              v-if="$can('company_add')"
              type="submit"
              :to="{ name: 'add-company' }"
              color="warning mt-2"
              large
              depressed
            >
              {{ $t('common.btns.addCompany') }}
            </v-btn>
          </v-layout>
        </v-flex>
      </v-layout>
      <v-layout wrap align-center>
        <v-flex
          xs12
          sm12
          md6
          lg5
          mt-4
          :class="{ 'mt-4': $vuetify.breakpoint.mdAndUp }"
        >
          <v-layout wrap align-center class="search-wrapper">
            <v-text-field
              class="search"
              ref="search"
              v-model="search"
              :placeholder="$t('companiesList.search.placeholder')"
              autocomplete="off"
              solo
            ></v-text-field>
            <v-btn
              type="button"
              class="search-btn warning mb-4"
              depressed
              large
              @click="searchCompanies"
            >
              {{ $t('common.btns.search') }}
            </v-btn>
          </v-layout>
        </v-flex>
        <v-flex
          xs12
          sm12
          md6
          lg7
          :class="{ 'mt-4': $vuetify.breakpoint.mdAndUp }"
          class="filter-wrapper"
        >
          <v-select
            :items="companiesStatuses"
            v-model="companyStatus"
            :label="$t('common.fields.status')"
            item-text="title"
            item-value="id"
            class="filter"
            :class="{ 'ml-4': $vuetify.breakpoint.mdAndUp }"
            @change="changeCompanyStatus($event)"
            return-object
          ></v-select>
        </v-flex>
      </v-layout>
    </v-flex>
    <v-flex xs12>
      <v-data-table
        :items="companiesList.items"
        :headers="headers"
        :loading="isLoading"
        :loading-text="$t('common.table.dataIsLoading')"
        :server-items-length="2"
        :mobile-breakpoint="100"
        class="table-custom companiesList small mb-4"
        hide-default-footer
      >
        <template slot="item" slot-scope="{ item }">
          <tr @click="goToCompanyPage(item.id)">
            <td>{{ item.num }}</td>
            <td class="text-xs-left">
              <v-layout align-center justify-start>
                {{ item.id }}
              </v-layout>
            </td>
            <td class="text-xs-left">{{ item.name }}</td>
            <td class="text-xs-left">{{ item.bin }}</td>
            <td class="text-xs-left">{{ item.investor }}</td>
            <td class="text-xs-left">{{ item.status }}</td>
          </tr>
        </template>
        <template slot="no-data">{{ $t('common.table.noData') }}</template>
      </v-data-table>
      <div v-if="paginationPage" class="text-xs-center">
        <v-pagination
          :value="paginationPage"
          :length="paginationLength"
          @input="choosePaginatorPage($event)"
        ></v-pagination>
      </div>
    </v-flex>
  </v-layout>
</template>

<script>
import { mapGetters, mapActions, mapMutations } from 'vuex';

export default {
  name: 'CompaniesListPage',
  components: {},
  data() {
    return {
      search: '',
      headers: [
        { text: this.$t('common.number'), sortable: false },
        { text: this.$t('companiesList.tableHeaders.id'), sortable: false },
        { text: this.$t('companiesList.tableHeaders.name'), sortable: false },
        { text: this.$t('companiesList.tableHeaders.bin'), sortable: false },
        {
          text: this.$t('companiesList.tableHeaders.investor'),
          sortable: false,
        },
        { text: this.$t('companiesList.tableHeaders.status'), sortable: false },
      ],
    };
  },
  watch: {
    /* eslint-disable */
    '$i18n.locale': async function() {
      await this.fetchCompaniesProperties();
      await this.fetchCompanies({
        page: this.paginationPage,
        searchString: this.search,
        companyStatus: this.companyStatus.id.toString(),
      });
      this.$vuetify.goTo(0, 'easeInOutCubic');
    },
  },
  computed: {
    ...mapGetters({
      isLoading: 'global/getLoader',
      companiesList: 'company/getCompaniesListData',
      companiesStatuses: 'company/getCompaniesStatuses',
      status: 'company/getCompanyStatus',
    }),
    companyStatus: {
      get() {
        return this.status;
      },
      set(value) {
        this.setCompanyStatus(value);
      },
    },
    paginationLength() {
      return this.companiesList.lastPage;
    },
    paginationPage() {
      if (
        this.companiesList.currentPage === 1 &&
        this.companiesList.lastPage === 1
      ) {
        return 0;
      }
      return this.companiesList.currentPage;
    },
  },
  async created() {
    await this.fetchCompaniesProperties();
    await this.fetchCompanies({
      page: 1,
      companyStatus: this.companyStatus.id.toString(),
    });
  },
  destroyed() {
    this.setCompaniesListData({});
    this.setCompaniesStatuses([]);
    this.setCompanyStatus(null);
    this.clearAlertError();
  },
  methods: {
    ...mapActions({
      fetchCompanies: 'company/fetchCompaniesListData',
      fetchCompaniesProperties: 'company/fetchCompaniesProperties',
    }),
    ...mapMutations({
      setCompaniesListData: 'company/setCompaniesListData',
      setCompaniesStatuses: 'company/setCompaniesStatuses',
      setCompanyStatus: 'company/setCompanyStatus',
      clearAlertError: 'global/clearAlertError',
    }),
    async searchCompanies() {
      await this.fetchCompanies({
        page: 1,
        searchString: this.search,
        companyStatus: this.companyStatus.id.toString(),
      });
    },
    async choosePaginatorPage(page) {
      await this.fetchCompanies({
        page,
        searchString: this.search,
        companyStatus: this.companyStatus.id.toString(),
      });
      this.$vuetify.goTo(0, 'easeInOutCubic');
    },
    goToCompanyPage(companyId) {
      this.$router.push(`/settings/companies/${companyId}`);
    },
    async changeCompanyStatus(status) {
      this.setCompanyStatus(status);
      await this.searchCompanies();
    },
  },
};
</script>

<style lang="scss" scoped>
.search-wrapper {
  .search {
    margin-right: -12px;
    margin-bottom: -12px;
    max-width: 325px;

    @media (max-width: 400px) {
      margin-right: 0px;
      margin-bottom: -12px;
      max-width: 100%;
    }
  }

  @media (max-width: 400px) {
    flex-direction: column;

    .search {
      width: 100%;
    }
  }
}
</style>
